import React from 'react';

import { Tooltip } from 'components';

import styles from './TruncateText.scss';
import { M } from 'components/typography';

type Props = {
  text: string;
  textVariant?: 'primary' | 'secondary';
  textWrap?: boolean;
  maxLength?: number;
  className?: string;
  style?: React.CSSProperties;
  withTooltip?: boolean;
  tooltipPlacement?: 'left' | 'top' | 'right' | 'bottom';
};

export const TruncateTextComponent: React.FC<Props> = ({
  text,
  textVariant = 'primary',
  textWrap = false,
  maxLength = 27,
  className,
  style,
  withTooltip = true,
  tooltipPlacement = 'top',
}) => {
  const isTruncated = text.length > maxLength && maxLength > 0;
  const truncatedText = isTruncated
    ? `${text.substring(0, maxLength)}...`
    : text;

  return (
    <M
      variant={textVariant}
      style={style}
      className={`${styles.customTooltip} ${
        tooltipPlacement === 'bottom' ? styles.customBottomRightPlacement : ''
      } ${textWrap ? styles.textWrap : ''} ${className || ''}`}
    >
      {withTooltip && isTruncated ? (
        <Tooltip
          TooltipComponent={<span>{text}</span>}
          placement={tooltipPlacement}
        >
          {truncatedText}
        </Tooltip>
      ) : (
        truncatedText
      )}
    </M>
  );
};
